import React, { useEffect, useState } from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Label,
  Input,
  Spinner,
} from 'reactstrap';
import Flatpickr from 'react-flatpickr';
import 'flatpickr/dist/themes/material_blue.css';
import { formatForFlatpickr } from '../../../../../../utils/dateformatpickr';

const EMPTY_FORM = {
  closingDateImprovement: '',
  message: '',
};

const CLOSING_DATE_FLATPICKR_OPTIONS = {
  enableTime: true,
  dateFormat: 'd/m/Y H:i',
  time_24hr: true,
};

const RequestImprovementModal = ({
  isOpen,
  onClose,
  onSubmit,
  isSubmitting = false,
  selectedCount = 0,
}) => {
  const [form, setForm] = useState(EMPTY_FORM);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (!isOpen) {
      setForm(EMPTY_FORM);
      setErrors({});
    }
  }, [isOpen]);

  const handleChange = e => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
    setErrors(prev => ({ ...prev, [name]: undefined }));
  };

  const validate = () => {
    const nextErrors = {};
    if (!form.closingDateImprovement) {
      nextErrors.closingDateImprovement =
        'Closing date improvement is required';
    }
    if (!String(form.message || '').trim()) {
      nextErrors.message = 'Message is required';
    }
    setErrors(nextErrors);
    return Object.keys(nextErrors).length === 0;
  };

  const handleSubmit = () => {
    if (!validate()) return;
    onSubmit?.(form);
  };

  return (
    <Modal isOpen={isOpen} toggle={onClose} centered backdrop='static'>
      <ModalHeader toggle={onClose}>
        Send Request Improvement
        {selectedCount > 0 ? (
          <span className='text-muted fs-13 fw-normal ms-2'>
            ({selectedCount} offer selected)
          </span>
        ) : null}
      </ModalHeader>
      <ModalBody>
        <FormGroup>
          <Label className='fw-semibold' for='closingDateImprovement'>
            Closing Date Improvement
          </Label>
          <Flatpickr
            id='closingDateImprovement'
            className={`form-control${errors.closingDateImprovement ? ' is-invalid' : ''}`}
            options={CLOSING_DATE_FLATPICKR_OPTIONS}
            value={formatForFlatpickr(form.closingDateImprovement) || ''}
            disabled={isSubmitting}
            onChange={dates => {
              setForm(prev => ({
                ...prev,
                closingDateImprovement: dates[0]?.toISOString() ?? '',
              }));
              setErrors(prev => ({
                ...prev,
                closingDateImprovement: undefined,
              }));
            }}
          />
          {errors.closingDateImprovement ? (
            <div className='invalid-feedback d-block'>
              {errors.closingDateImprovement}
            </div>
          ) : null}
        </FormGroup>
        <FormGroup className='mb-0'>
          <Label className='fw-semibold' for='message'>
            Message
          </Label>
          <Input
            id='message'
            name='message'
            type='textarea'
            rows={4}
            value={form.message}
            onChange={handleChange}
            invalid={!!errors.message}
            disabled={isSubmitting}
          />
          {errors.message ? (
            <div className='invalid-feedback d-block'>{errors.message}</div>
          ) : null}
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        <Button color='light' onClick={onClose} disabled={isSubmitting}>
          Close
        </Button>
        <Button color='primary' onClick={handleSubmit} disabled={isSubmitting}>
          {isSubmitting ? <Spinner size='sm' /> : 'Submit'}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default RequestImprovementModal;
